var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"holiday"},[_c('navbarStaff'),_c('div',{staticClass:"container"},[_c('FullCalendar',{ref:"fullCalendar",attrs:{"options":_vm.calendarOptions,"available-dates":{ start: new Date(), end: null }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }